import styled from "styled-components";
import { getColor, getSize, responsive } from "~/helpers/style";
import { UIProps } from "~/types/style";

export const PageTitle = styled.h1`
  font-weight: 700;
  font-size: ${getSize(2.4)};
  line-height: ${getSize(2.4)};
  text-align: center;

  @media (max-width: 768px) {
    font-weight: 600;
    font-size: ${getSize(1.55)};
    line-height: ${getSize(1.25)};
    margin-bottom: ${getSize(0.875)};
  }
`;

interface IPlansGrid extends UIProps {
  gap: number;
}

export const PlansGrid = styled.div<IPlansGrid>`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ gap }) => getSize(gap)};
  margin: auto;
  justify-content: center;
  align-items: stretch;
  width: 100%;
  @media(max-width: 600px) {
    flex-direction: column;
    align-items: center;
    margin: ${getSize(2)} auto ${getSize(2)} auto;
    gap: ${getSize(2)};
  }

`;

export const ToggleContentText = styled.p`
  margin: 0;
  font-size: ${getSize(1.3)};
  font-weight: 500;
  line-height: ${getSize(2.0)};
  color: #4B5B72;

  &.selected {
    font-weight: 500;
    color: #0c1835;
  }

  ${responsive("tablet", true)} {
    color: ${getColor("text")};
    font-family: "Inter Variable";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  @media (max-width: 768px) {
    font-size: ${getSize(1.4)};
  }
`;

export const PromotionText = styled.div`
  position: relative;
  background-color: ${getColor("greenSecondary")};
  color: ${getColor("green")};
  margin: 0;
  padding: ${getSize(0.2)} ${getSize(1)};
  border-radius: ${getSize(1)};
  font-size: ${getSize(1.2)};
  font-weight: 500;
  line-height: 1.35;
  white-space: normal;
  word-break: break-word;
`;

export const Arrow = styled.span`
  position: absolute;
  top: -20px;
  right: 73%;
  transform: translateX(50%);

  @media (max-width: 768px) {
  display: none;
  }
`;

export const DisclaimerBanner = styled.div`
  display: flex;
  align-items: center;
  gap: ${getSize(1.0)};
  color: black;
  background-color: #F3B430;
  padding: ${getSize(1.2)} ${getSize(1.6)};
  border-radius: ${getSize(0.6)};
  width: 500px;
  margin: auto;
  max-width: 100%;

  @media (max-width: 1024px) {
    padding: ${getSize(1.0)} ${getSize(1.2)};
    margin: ${getSize(1.6)} auto ${getSize(1.6)} auto;
    width: 100%;
    justify-content: center;
  }
`;

export const DisclaimerText = styled.span`
  font-size: ${getSize(1.4)};
  color: black;
  font-weight: 500;

  @media (max-width: 1024px) {
    font-size: ${getSize(1.2)};
  }
`;
